import React from 'react';

const MLNotificationBlockContext = React.createContext({
    messages: {},
    setMessages: () => {}
});

// Actions
const CLEAR_ALL = 'CLEAR_ALL';
const CLEAR_ERROR = 'CLEAR_ERROR';
const CLEAR_WARN = 'CLEAR_WARN';
const CLEAR_INFO = 'CLEAR_INFO';
const CLEAR_SUCCESS = 'CLEAR_SUCCESS';
const CLEAR_BLOCK = 'CLEAR_BLOCK';
const ADD_ERROR = 'ADD_ERROR';
const ADD_WARN = 'ADD_WARN';
const ADD_INFO = 'ADD_INFO';
const ADD_SUCCESS = 'ADD_SUCCESS';
const CLEAR_MANY_BLOCK = 'CLEAR_MANY_BLOCK';
const CLEAR_MANY_BLOCK_STARTS_WITH = 'CLEAR_MANY_BLOCK_STARTS_WITH';

const MLNotificationBlockReducer = (state, action) => {
    const { type, payload, block, onClick, alertHelpTitle, alertHelpMessage, blocks, separatedUndoFunc } = action;
    const newState = [...state];
    switch(type){
        case CLEAR_ALL:
            return [];
        case CLEAR_ERROR:
            return state.filter((message) => message.type !== 'error');
        case CLEAR_WARN:
            return state.filter((message) => message.type !== 'warning');
        case CLEAR_INFO:
            return state.filter((message) => message.type !== 'info');
        case CLEAR_SUCCESS:
            return state.filter((message) => message.type !== 'success');
        case CLEAR_BLOCK:
            return state.filter((message) => message.block !== block);
        case CLEAR_MANY_BLOCK:
            return state.filter((message) => !blocks.includes(message.block));
        case CLEAR_MANY_BLOCK_STARTS_WITH:
            return state.filter((message) => message.block && !message.block.startsWith(block));
        case ADD_ERROR:
            newState.push({type: 'error', message: payload, block: block, onClick: onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc});
            return newState;
        case ADD_WARN:
            newState.push({type: 'warning', message: payload, block: block, onClick: onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc});
            return newState;
        case ADD_INFO:
            newState.push({type: 'info', message: payload, block: block, onClick: onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc});
            return newState;
        case ADD_SUCCESS:
            newState.push({type: 'success', message: payload, block: block, onClick: onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc});
            return newState;
        default:
            return state;
    }
}

export { 
    MLNotificationBlockContext, 
    MLNotificationBlockReducer
};